import React from "react";
// import USMap from "../section/USMap";
import CustomerSupport from "../section/CustomerSupport";
import MovingProcess from "../section/MovingProcess";
import Services from "../section/Services";
import Map from "../section/Map";
import LandingHome from "../section/LandingHome";
import AboutSection from "../section/AboutSection";
// import Claims from "../section/Claims";
export default function Home(){
    return(
       <>
       <LandingHome/>
       <AboutSection/>
        {/* <USMap/> */}
        <Services/>
        {/* <Claims/> */}
        <MovingProcess/>
        <Map/>
        <CustomerSupport/>
       </>
    );
}